export const NOTIFICATION_INTERVAL_MS = 1250;